import {removeDiacritics, removeSmallWords, replaceWhiteSpaces} from 'Utils/textUtils';

/**
 * @description Check the data attribute needed for the analytics to work.
 * @param {HTMLElement} domElement - Check the data attribute on the dom element.
 * @returns {string} - The Label for analytics.
 */
export const guessLabel = domElement => {
    const prefix = (domElement.dataset.analyticsLabelPrefix || '').trim();
    const rawLabel = (domElement.dataset.analyticsLabel || domElement.textContent).trim().toLocaleLowerCase();
    const label = removeSmallWords(removeDiacritics(replaceWhiteSpaces(rawLabel)));

    return label ? `${prefix}${label}` : null;
};

/**
 * @description Build the sendTag event that will send the analytics details.
 * @param {object} detail - Object with the details of the sendTag event.
 * @returns {Event} - Custom Event with the details for analytics.
 */
export const buildSendTagEvent = detail => {
    let sendTagEvent;

    try {
        sendTagEvent = new CustomEvent('sendTag', {bubbles: true, cancelable: false, detail});
    } catch (error) {
        sendTagEvent = document.createEvent('CustomEvent');
        sendTagEvent.initCustomEvent('sendTag', true, false, detail);
    }

    return sendTagEvent;
};

/**
 * @description Set the type of click event.
 * @param {HTMLElement} domElement - Data attribute that will se the click type.
 * @returns {string} Analytics Click Type.
 */
export const guessClickType = domElement => domElement.dataset.analyticsClickType || 'A';

/**
 * @description Build the object that will be pass to analytics.
 * @param {object} obj - Build the object and delete undefined properties.
 * @returns {object} With analytics settings.
 */
export const buildSendTagObj = obj => {
    let sendTagObj = {};

    for(const key in obj) {
        if(obj[key] || obj[key] === 0) {
            sendTagObj = {[key]: obj[key], ...sendTagObj};
        }
    }
    return sendTagObj;
};

/**
 * @description Build and send the sendTag event with the info.
 * @param {object} sendTagObj - The analytics object that will be send.
 * @param {string} [sendTagObj.clickType=N] - Type of click on the event.
 * @param {string} sendTagObj.label - Type of click on the event.
 * @param {object} sendTagObj.data - Object with the data for analytics.
 * @param {string} [sendTagObj.event=C] - Type of event on the that will be send.
 */
export const runDispatchEvent = ({clickType = 'N', label, data, event = 'C'}) => {
    const sendTagObj = {
        Event: event,
        Type: clickType
    };

    if(label) {
        sendTagObj.Label = label;
    }

    if(data) {
        sendTagObj.Datalayer = buildSendTagObj(data);
    }

    window.dispatchEvent(buildSendTagEvent(buildSendTagObj(sendTagObj)));
};
